import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaRoczniceFirmy = () => (
  <SeoPageLayout title="Kabaret na rocznicę firmy - świętuj sukcesy z humorem">
    <p>
      Rocznica firmy to moment podsumowania dokonań i celebrowania wspólnej drogi. Kabaret na rocznicę firmy to elegancka i zabawna atrakcja, która uświetni obchody i sprawi, że pracownicy, partnerzy i klienci poczują ducha wspólnoty.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na okrągłe rocznice</h2>
    <p>
      Okrągłe rocznice - 5, 10, 25, 50 lat na rynku - zasługują na wyjątkową oprawę. Występ kabaretowy na rocznicy firmy to personalizowany program, który nawiązuje do historii organizacji, jej kamieni milowych i zabawnych anegdot z życia firmowego.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Program rocznicowy</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Retrospektywa w formie kabaretowej - historia firmy oczami satyryka</li>
      <li>Wywiady z założycielami - humorystyczne rozmowy na scenie</li>
      <li>Nagrody i wyróżnienia - wręczanie w komediowej oprawie</li>
      <li>Parodie reklam i produktów - śmiech z własnej branży</li>
      <li>Toast jubileuszowy - humorystyczne przemówienie na cześć firmy</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Dlaczego kabaret na rocznicę?</h2>
    <p>
      Rocznica firmy to czas dumy i radości. Kabaret pozwala celebrować sukcesy z dystansem i humorem, przypominając, że za każdą wielką firmą stoją ludzie z poczuciem humoru. To inwestycja w kulturę organizacyjną i pozytywny wizerunek.
    </p>
  </SeoPageLayout>
);

export default KabaretNaRoczniceFirmy;
